import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '@methylium/core';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable()
export class LoggingService {
  private angularPlugin = new AngularPlugin();
  private appInsights: ApplicationInsights;
  constructor(
    private readonly environmentService: EnvironmentService,
    private router: Router
  ) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.environmentService.environment.appInsights?.instrumentationKey,
        extensions: [this.angularPlugin],
        extensionConfig: {
          [this.angularPlugin.identifier]: {
            router: this.router,
            errorServices: [new ErrorHandler()],
          },
        },
        enableAutoRouteTracking: true, // option to log all route changes
      },
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: Record<string, unknown>) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: Record<string, unknown>) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: Record<string, unknown>) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
